import { Box } from "@chakra-ui/react";
import { AttendanceKanbanContextProvider } from "components/atendimentos-components/kanban-and-table-atendimento/kanban/kanban-context";
import { GetLayout } from "components/get-layout";
import { useEffect, useRef, useState } from "react";
import { KanbanAndTableAtendimento } from "components/atendimentos-components/kanban-and-table-atendimento";
import { Navbar3cplusTemplate } from "components/atendimentos-components/navbar-3cplus-template";
import { PageSelect } from "components/atendimentos-components/page-select-tab";
import { use3cPlusContext } from "contexts/Context3cPlus";
import { useApplicationContext } from "contexts/ApplicationContext";
import { AbaPropostas } from "components/atendimentos-components/aba-oportunidades-esteira-nova";
import { RoutePermissionFunction } from "router-manager/parts";

export default function AtendimentoNovoKanban() {
  const [currentPage, setCurrentPage] = useState("Atendimento");
  const pageContainerRef = useRef<HTMLDivElement>(null);
  const { controls3cPlus } = use3cPlusContext();
  const { setMenuErrorMessage } = useApplicationContext();

  useEffect(() => {
    if (!controls3cPlus.inCall) {
      setMenuErrorMessage(undefined);
    }
  }, [controls3cPlus.inCall]);

  return (
    <GetLayout
      HeadRender={Navbar3cplusTemplate}
      pageContentProps={{ p: `0px`, overflow: "auto" }}
    >
      <AttendanceKanbanContextProvider>
        <PageSelect currentPage={currentPage} setCurrentPage={setCurrentPage} />
        <Box w="100%" ref={pageContainerRef}>
          {currentPage === "Atendimento" ? (
            <KanbanAndTableAtendimento />
          ) : currentPage === "Propostas" ? (
            <AbaPropostas />
          ) : null}
        </Box>
      </AttendanceKanbanContextProvider>
    </GetLayout>
  );
}

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.setUserTypesPermission([
    "SUPER",
    "REGIONAL",
    "COMERCIAL",
    "PARCEIRO_GERENTE_ESTRATEGICO",
    "PARCEIRO_GERENTE_VAREJO",
    "PARCEIRO_MASTER",
    "PARCEIRO_VENDEDOR",
    "PARCEIRO_OPERACIONAL",
    "ASCOM"
  ]);
  route.setColomboUserTypesPermission([
    "PARCEIRO_GERENTE_ESTRATEGICO",
    "PARCEIRO_GERENTE_VAREJO",
    "PARCEIRO_MASTER",
    "PARCEIRO_VENDEDOR"
  ]);
};
